module.exports = __webpack_public_path__ + "static/media/trainingBannerImage.33fa81e5.png";